module.exports = __webpack_public_path__ + "img/ラヴィリンソス.2b5d1083.png";